import { object, string } from "yup";

export const complianceValidation = object({
  name: string().required(),
  compliance_type: string().required(),
  frequency: string().required(),
});
